import React from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';

const App = () => (
  <>
    <Components />
    <ScrolToTop />
  </>
);

export default App;
